export enum SubscriptionContentType {
  LIVE_STREAM = 'livestream',
  REPLAY = 'replay',
  HIGHLIGHTS = 'highlights',
  ACTIVITY = 'activity',
  NEWS = 'news'
}
